/**
 * Required External Modules
 */
import App from "./App.vue";
import router from "./router";
import { createApp } from "vue";
import { createPinia } from "pinia";
import PrimeVue from "primevue/config";
import ToastService from "primevue/toastservice";
import Toast from "primevue/toast";
import ProgressBar from "primevue/progressbar";
import { plugin, defaultConfig, createInput } from "@formkit/vue";
import piniaPluginPersistedstate from "pinia-plugin-persistedstate";
import i18n from "./plugins/i18n";
import { setupCalendar } from "v-calendar";
import formkitConfig from "../formkit.config";

/**
 * Import main css file
 */
import "./styles/main.scss";

/**
 * Import directives
 */
import directives from "./directives";

/**
 * Register Service Worker
 */
import "./registerServiceWorker";

/**
 * Import Components
 */
import ModalComponent from "./components/global/ModalComponent.vue";
import RLIconComponent from "./components/global/RLIconComponent.vue";
import SpinnerComponent from "./components/global/SpinnerComponent.vue";
import TooltipComponent from "./components/global/TooltipComponent.vue";

import SearchInputComponent from "./components/forms/SearchInputComponent.vue";
import ChooseInputComponent from "./components/forms/ChooseInputComponent.vue";

const app = createApp(App);

directives(app);

app
  .use(router)
  .use(PrimeVue)
  .use(ToastService)
  .component("ProgressBar", ProgressBar)
  .component("Toast", Toast)
  .component("modal", ModalComponent)
  .component("rl-icon", RLIconComponent)
  .component("tooltip", TooltipComponent)
  .component("spinner-loader", SpinnerComponent)
  .use(createPinia().use(piniaPluginPersistedstate))
  .use(
    plugin,
    defaultConfig({
      ...formkitConfig,
      inputs: {
        search: createInput(SearchInputComponent, {
          props: ["searchOptions", "placeholder"],
        }),
        choose: createInput(ChooseInputComponent, {
          props: ["selectOptions", "placeholder"],
        }),
      },
    })
  )
  .use(i18n)
  .use(setupCalendar, {})
  .mount("#app");
